import { Grid, makeStyles, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";

import { Icon } from "../../../components/base";
import { LocationIcon } from "../../../components/map/LocationIcon";
import UserCircleIcon from "../../../assets/images/icons/userCircle.png";
import RemoveIcon from "../../../assets/images/icons/remove.svg";
import { COLORS } from "../../../theme/colors";
import { nFormatter } from "../../../services/utils";
import { MAP_ICON_COLORS } from "../constants";

const useStyles = makeStyles((theme) => ({
  addressContainer: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  title: {
    fontWeight: "bold",
  },
  subTitle: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  sqft: {
    color: COLORS.darks[0][50],
  },
}));

export const Header = ({ building, title, hideTenants, onClose }) => {
  const classes = useStyles();
  const { user } = useSelector((state) => state.auth);

  return (
    <>
      <Grid container justifyContent="space-between" alignItems="center">
        <Typography className={classes.title} variant="h2">
          {title}
        </Typography>
        <Icon src={RemoveIcon} hoverable onClick={onClose} />
      </Grid>

      <Grid className={classes.addressContainer} container alignItems="center">
        <LocationIcon width={22} color={MAP_ICON_COLORS[building.status]} />
        <Typography className={classes.subTitle} variant="h4">
          {building.address}
        </Typography>
        <Typography className={classes.sqft}>
          {building.total_square ? `${nFormatter(building.total_square)} ${user?.unit_system}` : ""}
        </Typography>
      </Grid>

      {!hideTenants && (
        <Grid container alignItems="center">
          <Icon src={UserCircleIcon} />
          <Typography className={classes.subTitle} variant="h4">
            {building.tenants ? building.tenants : "0"} Tenants
          </Typography>
        </Grid>
      )}
    </>
  );
};
